// src/types/AuthState.ts
import type { MLKEMKeyPair } from '@/services/abstract/poc/crypto.service.interface';

export type RegistrationStep = 'emailCode' | 'phoneCode' | 'password' | 'complete';

export type LoginStep = 'credentials' | 'choose2fa' | 'verify2fa' | 'authenticated';

export type TwoFactorMethod = 'sms' | 'email';

export type UserType = 'Internal' | 'External';

export type FieldErrors = Record<string, string | undefined>;

export type SetPasswordStage = 'preCommit' | 'postCommit';

export interface PasswordSetupPayload {
  userId: string;
  ukek: string;
  derivedKey: string;
  keyPair: MLKEMKeyPair;
  encryptedPrivateKey: string;
}

export interface CredentialsVerificationThunkData {
  sessionToken: string;
}

export interface AuthState {
  status: 'idle' | 'loading' | 'authenticated' | 'error';
  loginStep: LoginStep;
  userId: string | null;
  username: string;
  userName?: string;
  error?: string;
  sessionToken?: string;
  registrationStep?: RegistrationStep;
  isSubmitting: boolean;
  registrationToken?: string;
  regToken?: string;
  ukek: string;
  decapsKey: string;
  fieldErrors: FieldErrors;
  twoFactorMethod?: TwoFactorMethod;
  twoFactorMaskedDestination?: string;
  twoFactorExpiresInSeconds?: number;
  forgotPasswordEmailAddress?: string;
  recoveryMaskedPhone?: string;
  recoveryToken?: string;
  userType: UserType | null;
  setPasswordStage?: SetPasswordStage;
}

export const initialAuthState: AuthState = {
  loginStep: 'credentials',
  status: 'idle',
  userId: null,
  username: '',
  userName: undefined,
  registrationStep: undefined,
  isSubmitting: false,
  registrationToken: undefined,
  ukek: '',
  decapsKey: '',
  fieldErrors: {},
  twoFactorMethod: undefined,
  twoFactorMaskedDestination: undefined,
  twoFactorExpiresInSeconds: undefined,
  userType: null,
};
